import { render, staticRenderFns } from "./ModalAddMissingAnswerImage.vue?vue&type=template&id=207a0451"
import script from "./ModalAddMissingAnswerImage.vue?vue&type=script&lang=js"
export * from "./ModalAddMissingAnswerImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports